import React from 'react'
import './about.css'
import ME3 from '../../acesset/reignsB.jpeg'
import {FaAward} from  'react-icons/fa'
import {FiUsers} from  'react-icons/fi'
import {VscFolderLibrary} from  'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>
     
      <div className='container about__container'>
        <div className='about__me'>
          <div className='about__me-image'>
            <img src={ME3} alt="Sadiq Haruna" />
          </div>
        </div>

        <div className='about__content'>
          <div className='about__cards'>
            <article className='about__card'>
              <FaAward className='about__icons' />
              <h5>Experience</h5>
              <small>4+ Years Professional</small>
            </article>

            <article className='about__card'>
              <FiUsers className='about__icons' />
              <h5>Clients</h5>
              <small>25+ Worldwide</small>
            </article>

            <article className='about__card'>
              <VscFolderLibrary className='about__icons' />
              <h5>Projects</h5>
              <small>38+ Delivered</small>  
            </article>
          </div>

          <div className='about__story'>
            <h2>High-Impact Frontend Engineer & Product Builder</h2>
            <p>
              I'm a <strong>full-stack engineer</strong> specializing in building <strong>production-grade healthcare and enterprise systems</strong>. With a degree in Management Information Technology and 4+ years of professional experience, I've delivered complex solutions for governments, institutions, and startups worldwide.
            </p>
            <p>
              My expertise goes beyond code—I think in terms of <strong>product usability, business value, and scalable architecture</strong>. I've built patient-doctor-pharmacist platforms, anti-ghost-worker systems, and tablet-locked hospital applications that solve real-world problems.
            </p>
            <p>
              Currently transitioning into <strong>AI-powered applications</strong>, integrating intelligent features into healthcare software, chatbots, and decision-support systems. I'm passionate about building <strong>startup-ready MVPs</strong> that attract investors and institutions.
            </p>
            
            <div className='about__focus'>
              <h3>🎯 Career Focus</h3>
              <p>
                <strong>Open to remote roles</strong> with global companies and startups in <strong>health-tech and enterprise software</strong>. I build beautiful UIs, complex systems, and real-world solutions that drive business value.
              </p>
            </div>
          </div>

          <div className='about__cta'>
            <a href='#contact' className='btn btn-primary'>Let's Talk</a>
            <a href='https://moreaboutsadiq.netlify.app/' target='_blank' rel="noreferrer" className='btn'>More About Me</a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
